import CryptoJS from 'crypto-js'

export function generateKey (num) {
  var library = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let key = ''
  for (var i = 0; i < num; i++) {
    var randomPoz = Math.floor(Math.random() * library.length)
    key += library.substring(randomPoz, randomPoz + 1)
  }
  return key
}

// 加密
export function encrypt (word, keyStr, ivStr) {
  var key = CryptoJS.enc.Base64.parse(keyStr)
  var iv = CryptoJS.enc.Base64.parse(ivStr)
  var src = CryptoJS.enc.Utf8.parse(word)
  var encrypted = CryptoJS.AES.encrypt(src, key, { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7, iv: iv })
  return encrypted.toString()
}

// 解密
export function decrypt (word, keyStr, ivStr) {
  var key = CryptoJS.enc.Base64.parse(keyStr)
  var iv = CryptoJS.enc.Base64.parse(ivStr)
  var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7, iv: iv })
  return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}

// MD5
export function md5 (str) {
  return CryptoJS.MD5(str).toString();
}
